import React from 'react';
import IssueTypesLegend from './issue-types-legend';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';
import type { Props } from './types';

const Legend = ({ enrichedHierarchyLevels, filteredIssues }: Props) => (
	<div
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
		className={styles.root}
		data-testid="portfolio-3-portfolio.app-confluence-macro.main-new.common.legend.legend"
	>
		{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
		<div className={styles.section}>
			<IssueTypesLegend
				enrichedHierarchyLevels={enrichedHierarchyLevels}
				filteredIssues={filteredIssues}
			/>
		</div>
	</div>
);

export default Legend;
